import { apiRequest } from "../functions/apiRequest";
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  IconButton,
  Drawer,
  Popover,
  Badge,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import config from "../config.json";
import { BRAND_NAME } from "../../config/constants";
const PREFIX = 'Navbar';

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  logo: `${PREFIX}-logo`,
  logo1: `${PREFIX}-logo1`,
  menuButton: `${PREFIX}-menuButton`,
  menuButtonM: `${PREFIX}-menuButtonM`
};

const Root = styled('header')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    flexGrow: 1,
  },

  [`& .${classes.header}`]: {
    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
    color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
    boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.5)",
  },

  [`& .${classes.logo}`]: {
    fontFamily: "Cinzel",
    fontSize: "2.5rem",
    textAlign: "left",
    verticalAlign: "center",
    color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
  },

  [`& .${classes.logo1}`]: {
    fontFamily: "Cinzel",
    fontSize: "2rem",
    textAlign: "left",
    verticalAlign: "center",
    color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
  },

  [`& .${classes.menuButton}`]: {
    display: "inline-flex",
    justifyContent: "space-evenly",
    marginLeft: "3px",
    marginRight: "6px",
    paddingLeft: "4px",
    paddingRight: "4px",
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
    textTransform: "none",
    borderRadius: 20,
  },

  [`& .${classes.menuButtonM}`]: {
    padding: "0px",
    display: "flex",
    justifyContent: "center",
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 800,
    fontSize: 20,
    color: config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
    textTransform: "none",
    borderRadius: 100,
  }
}));

const token = localStorage.getItem("token");
const stringifiedUser = localStorage.getItem("user");
const user = JSON.parse(stringifiedUser);

const logout = () => {
  const itemsToRemove = [
    "token",
    "userID",
    "first_name",
    "email_id",
    "user",
    "pic",
    "parent_token",
    "parent_id",
  ];
  itemsToRemove.forEach((item) => localStorage.removeItem(item));
  window.location.href = "/";
};

function Navbar() {
  const isSocialCreds = process.env.REACT_APP_HOST_NAME === "socialcreds";
  const brandTitle =
    isSocialCreds
      ? BRAND_NAME
      : (process.env.REACT_APP_TITLE || BRAND_NAME);

  useEffect(() => {
    document.title = brandTitle;
  }, [brandTitle]);

  const getInvolvedTab = {
    text: "Get Involved",
    isDropdown: true,
    nestedButtons: [
      { text: "About Us", href: "/about" },
      { text: "Contact Us", href: "/contact-us" },
    ],
  };

  const commonTabs = [
    { text: "Home", href: "/" },
    {
      text: "Blogspot",
      href: "/blogspot",
    },
    {
      text: "Donate",
      href: "/donate",
      bGround: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
      fontClr: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
    },
  ];

  if (user) {
    commonTabs.push(getInvolvedTab);
    if (process.env.REACT_APP_HOST_NAME === "socialcreds") {
        getInvolvedTab.nestedButtons.push({ text: "Team", href: "/team" });
      }
   
  } else {
    commonTabs.push({ text: "About Us", href: "/about" });
    commonTabs.push({ text: "Contact Us", href: "/contact-us" });
    if (process.env.REACT_APP_HOST_NAME === "socialcreds") {
      commonTabs.push({ text: "Team", href: "/team" });
    }
  }

  const userTabs = [
    { text: "Launch Program", href: "/programs/create" },
    { text: "Human Library", href: "/human-library" },
    { text: "Dashboard", href: "/dashboard" },
    {
      text: "Profile",
      isDropdown: true,
      nestedButtons: [
        { text: "Credit Exchange", href: "/inbox" },
        { text: "Choose Profile", href: "/profiles/choose" },
        { text: "View Profile", href: "/profile" },
        { text: "Logout", href: "/", action: logout },
      ],
    },
  ];

  const otherTabs = [
    { text: "Login", href: "/login" },
    { text: "Sign up", href: "/signup/offer" },
  ];

  const [navigationTabs, setNavigationTabs] = useState(commonTabs);

  const tabOrder = [
    "Home",
    "Blogspot",
    "Launch Program",
    "Human Library",
    "Dashboard",
    "Donate",
    "About",
    "Team",
    "About Us",
    "Get Involved",
    "Contact Us",
    "Profile",
    "Login",
    "Sign up",
  ];

  const getTabsInOrder = (tabs, order) => {
    return order
      .map((tabName) => tabs.find((tab) => tab.text === tabName))
      .filter(Boolean);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmit = async (id) => {
    const body = JSON.stringify({ id: id });
    await apiRequest("DELETE", body, `/user/msgs/${id}`, token);
  };

  const handleSubmit1 = async (id) => {
    const body = JSON.stringify({ id: id });
    await apiRequest("DELETE", body, `/notif/send/${id}`, token);
    window.location.reload();
  };

  const addUser = async (prog_id, id, notif_id, prog_name) => {
    try {
      const body = JSON.stringify({ id: id });
      await apiRequest("GET", body, `/adduser/${prog_id}/${id}`, token);
      handleSubmit1(notif_id);
    } catch (error) {
      // console.error('There was an error:', error);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;


  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;

  if ((!user && token) || (user && !user.profile_pic && token)) {
    logout();
  }
  
  const [notifs, setNotifs] = useState([]);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (window.location.pathname === "/dashboard" && token) {
          // Fetch notifications
          const notifResponse = await fetch(
            process.env.REACT_APP_API_URL + `/api/notif/list/1`,
            {
              method: "GET",
              headers: {
                Authorization: `Token ${token}`,
              },
            }
          );
          const notifData = await notifResponse.json();
          setNotifs(notifData);

          // Fetch user messages
          const msgResponse = await fetch(
            process.env.REACT_APP_API_URL + "/api/user/msgs",
            {
              method: "GET",
              headers: {
                Authorization: `Token ${token}`,
              },
            }
          );
          const msgData = await msgResponse.json();
          setMsgs(msgData);
        }
        const orderedTabs = getTabsInOrder(
          [...commonTabs, ...(user ? userTabs : otherTabs)],
          tabOrder
        );
        setNavigationTabs(orderedTabs);
      } catch (error) {
        // console.error(error);
      }
    };

    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    fetchData();
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
    // eslint-disable-next-line
  }, []);

  const DisplayDesktop = () => {
    const generateButton = (button) => (
      <>
        {button.text !== "Get Involved" && button.text !== "Profile" ? (
          <Button
            className={classes.menuButton}
            style={{ borderRadius: 20, width: "auto" }}
            href={button.href}
            target={button.target}
            rel={button.rel}
          >
            <Typography style={{ fontFamily: "Raleway" }}>
              {button.text}
            </Typography>
          </Button>
        ) : button.isDropdown ? (
          <div className="dropdown" style={{ textAlign: "center" }}>
            <Button
              className={classes.menuButton}
              style={{
                borderRadius: 20,
                width: "auto",
                textTransform: "none",
                color:
                  config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
                borderColor: "#f26627",
              }}
              href={button.href}
            >
              {user && button.text === "Profile" ? (
                <>
                  <img
                    alt="profile"
                    src={user["profile_pic"]}
                    style={{ height: 35, width: 35, borderRadius: 100 }}
                  ></img>
                  &nbsp;
                  <Typography
                    style={{
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .headerFontColor,
                      fontSize: 16,
                      fontFamily: "Raleway",
                      zIndex: 30,
                    }}
                  >
                    {user["first_name"]}
                  </Typography>
                </>
              ) : (
                <>
                  {" "}
                  <Typography
                    style={{
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .headerFontColor,
                      fontSize: 16,
                      fontFamily: "Raleway",
                      zIndex: 30,
                    }}
                  >
                    {button.text}
                  </Typography>
                </>
              )}
            </Button>

            {button.isDropdown && (
              <div className="dropdown-content" style={{ textAlign: "center" }}>
                {button.nestedButtons.map((nestedButton) => (
                  <a
                    key={nestedButton.text}
                    href={nestedButton.href}
                    onClick={nestedButton.action}
                  >
                    {nestedButton.text}
                  </a>
                ))}
              </div>
            )}
          </div>
        ) : null}
      </>
    );

    const renderDashboard = () => (
      <>
        <Button className={classes.menuButtonM} onClick={handleClick}>
          <Typography style={{ fontFamily: "Raleway" }}>
            <Badge
              overlap="rectangular"
              badgeContent={
                notifs ? (msgs ? msgs.length + notifs.length : "") : ""
              }
              color="primary"
            >
              <NotificationsIcon />
            </Badge>
          </Typography>
        </Button>
        {renderNotificationsPopover()}
      </>
    );

    const renderNotificationsPopover = () => (
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ overflowY: "scroll", maxHeight: 240 }}>
          {[...msgs, ...notifs].map((info, idx) => (
            <Grid
              key={idx}
              container
              style={{
                textAlign: "center",
                outlineStyle: "inherit",
                borderBottom: "0.1px solid lightgrey",
              }}
            >
              <Grid item xs={12}>
                {info.message && (
                  <Typography style={{ marginTop: 15 }}>
                    {info.message}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                {info.notif_type && (
                  <>
                    {info.program && (
                      <>
                        <Button
                          onClick={() =>
                            addUser(info.program, info.from_user, info.id)
                          }
                        >
                          <i
                            className="material-icons"
                            style={{ color: "green", marginBottom: 5 }}
                          >
                            check_circle
                          </i>
                        </Button>
                        <Button onClick={() => handleSubmit1(info.id)}>
                          <i
                            className="material-icons"
                            style={{ color: "red" }}
                          >
                            cancel
                          </i>
                        </Button>
                      </>
                    )}
                    <br />
                  </>
                )}

                {!info.notif_type && (
                  <>
                    <Button onClick={() => handleSubmit(info.id)}>
                      <i
                        className="material-icons"
                        style={{ color: "red", marginBottom: 5 }}
                      >
                        cancel
                      </i>
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          ))}
        </div>
      </Popover>
    );

    return (
      <Toolbar style={{ height: 56, minHeight: 56, display: "flex", alignItems: "center" }}>
        <div>
          <a
            href={window.location.origin}
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              textDecoration: "none",
            }}
          >
            <img
              alt="logo"
              src={`${process.env.REACT_APP_R2_URL}/${process.env.REACT_APP_HOST_NAME}.jpeg`}
              style={{
                height: 38,
                width: 38,
                borderRadius: "50%",
                marginRight: 8,
              }}
            />
            <Typography
              variant="h6"
              style={{
                fontFamily: isSocialCreds ? "'Raleway', sans-serif" : "Cinzel",
                fontWeight: isSocialCreds ? 800 : 700,
                fontSize: "1.3rem",
                letterSpacing: isSocialCreds ? "0.3px" : "0.5px",
              }}
            >
              {brandTitle}
            </Typography>
          </a>
        </div>

        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          {navigationTabs.map((button) => generateButton(button))}

          {user && window.location.pathname === "/dashboard" && (
            <>{renderDashboard(user)}</>
          )}
        </div>
      </Toolbar>
    );
  };

  const DisplayMobile = () => {
    const handleDrawerOpen = () => {
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    };
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    const generateButton = (button) => (
      <Grid item xs={12} key={button.text} style={{ textAlign: "center" }}>
        {button.text !== "Profile" && button.text !== "Get Involved" && (
          <Button
            onClick={button.action}
            href={button.href}
            target={button.target}
            rel={button.rel}
            style={{
              fontFamily: "Raleway",
              backgroundColor: `${button.bGround}`,
              color: button.fontClr ? button.fontClr : "black"
            }}
          >
            <Typography>{button.text}</Typography>
          </Button>
        )}
        {button.nestedButtons && (
          <div style={{ textAlign: "center" }}>
            {button.nestedButtons.map((nestedButton) =>
              generateButton(nestedButton)
            )}
          </div>
        )}
      </Grid>
    );

    return (
      <Toolbar style={{ height: 56, minHeight: 56 }}>
        <IconButton
          {...{
            edge: "start",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
          size="large">
          <MenuIcon />
        </IconButton>

        <Drawer
          {...{
            anchor: "left",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <Grid container style={{ textAlign: "center" }}>
            <Grid item xs={11}>
              <Typography
                style={{
                  height: "9vh",
                  textAlign: "center",
                  fontSize: 40,
                  paddingLeft: "10vw",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
                  backgroundColor:
                    config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                  fontFamily: "Raleway",
                }}
              >
                Menu
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              style={{
                backgroundColor:
                  config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
              }}
            >
              <Button
                onClick={handleDrawerClose}
                style={{
                  backgroundColor:
                    config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                  height: "9vh",
                  float: "right",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                  fontSize: 40,
                }}
              >
                <i
                  className="material-icons"
                  style={{
                    color:
                      config[process.env.REACT_APP_HOST_NAME].css
                        .headerFontColor,
                  }}
                >
                  cancel
                </i>
              </Button>
            </Grid>
            <Grid item xs={12}>
              <img
                alt={"logo"}
                src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`}
                style={{ height: 219, width: 200 }}
              ></img>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              <Typography
                variant="h1"
                style={{ fontFamily: "Raleway", fontSize: 16 }}
              >
                One of the greatest gifts you can give is the gift of time.
              </Typography>
            </Grid>

            {navigationTabs.map((button) => generateButton(button))}
          </Grid>
        </Drawer>

        <Typography
          style={{
            fontSize: 20,
            fontFamily: isSocialCreds ? "'Raleway', sans-serif" : "Cinzel",
            fontWeight: isSocialCreds ? 800 : 700,
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          {brandTitle}
        </Typography>

        <Button onClick={handleClick}>
          <Typography style={{ fontFamily: "Raleway" }}>
            <Badge
              overlap="rectangular"
              badgeContent={
                notifs ? (msgs ? msgs.length + notifs.length : "") : ""
              }
              color="primary"
            >
              <NotificationsIcon
                style={{
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css.headerFontColor,
                }}
              />
            </Badge>
          </Typography>
        </Button>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div style={{ overflowY: "scroll", maxHeight: 240 }}>
            {msgs.length > 0
              ? msgs.map((info, idx) => {
                  return (
                    <Grid
                      key={idx}
                      container
                      style={{
                        textAlign: "center",
                        outlineStyle: "inherit",
                        borderBottom: "0.1px solid lightgrey",
                      }}
                    >
                      <Grid item xs={10}>
                        <br></br>
                        <Typography style={{ marginBottom: 2 }} gutterBottom>
                          {info.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <Button
                          style={{ marginTop: 13 }}
                          onClick={() => {
                            handleSubmit(info.id);
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{ color: "red" }}
                          >
                            cancel
                          </i>
                        </Button>
                        <br></br>
                      </Grid>
                    </Grid>
                  );
                })
              : ""}
            {notifs.length > 0
              ? notifs.map((info, idx) => {
                  return (
                    <Grid
                      key={idx}
                      container
                      style={{ textAlign: "center", outlineStyle: "inherit" }}
                    >
                      <Grid item xs={12}>
                        <br></br>
                        <Typography>{info.message}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          onClick={() => {
                            addUser(info.program, info.from_user, info.id);
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{ color: "green" }}
                          >
                            check_circle
                          </i>
                        </Button>
                        <Button
                          onClick={() => {
                            handleSubmit1(info.id);
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{ color: "red" }}
                          >
                            cancel
                          </i>
                        </Button>
                        <br></br>
                      </Grid>
                    </Grid>
                  );
                })
              : ""}
          </div>
        </Popover>
      </Toolbar>
    );
  };

  return (
    <Root>
      <AppBar className={classes.header}>
        {mobileView ? DisplayMobile() : DisplayDesktop()}
      </AppBar>
    </Root>
  );
}

export default Navbar;
